export const NAME = 'sponsorship';

// User Registration constants
export const SEND_INVITATIONS_REQUEST = 'SEND_INVITATIONS_REQUEST';
export const SEND_INVITATIONS_SUCCESS = 'SEND_INVITATIONS_SUCCESS';
export const SEND_INVITATIONS_FAILURE = 'SEND_INVITATIONS_FAILURE';

export const SEND_INVITATION_REMINDS_REQUEST = 'SEND_INVITATION_REMINDS_REQUEST';
export const SEND_INVITATION_REMINDS_SUCCESS = 'SEND_INVITATION_REMINDS_SUCCESS';
export const SEND_INVITATION_REMINDS_FAILURE = 'SEND_INVITATION_REMINDS_FAILURE';

export const SEND_PURCHASE_REMINDS_REQUEST = 'SEND_PURCHASE_REMINDS_REQUEST';
export const SEND_PURCHASE_REMINDS_SUCCESS = 'SEND_PURCHASE_REMINDS_SUCCESS';
export const SEND_PURCHASE_REMINDS_FAILURE = 'SEND_PURCHASE_REMINDS_FAILURE';



// WEBPACK FOOTER //
// ./src/services/sponsorship/constants.js